import { BASE_STATIC_URL } from '../../config'
import { getPropsFromNode } from '../utils'
import LinkWrapper from '../../components/atom/link-wrapper'
import { h } from '../parser/utils'

export const NAME = 'internal-links'

const BLOG_ABSOLUTE_URL_REGEX = /(?:https?:)?\/\/(?:www.)?blog.nonsensebb.com\/?(.*)?/

export const COMPONENTS = {
  LinkWrapper,
}

export function matches(node) {
  const elementName = node.nodeName.toLowerCase()

  if (elementName !== 'a' || !node.attributes['href']) {
    return false
  }

  const href = node.attributes['href'].value || ''

  return href.startsWith('/') || href.match(BLOG_ABSOLUTE_URL_REGEX)
}

export async function transform (node, next, ctx) {
  // TODO: detect type of link and build correct props for LinkWrapper for client side navigation
  const props = {
    ...getPropsFromNode(node, ['href']),
    href: processHref(node.attributes['href'].value || ''),
  }

  const children = await next(node.childNodes, ctx)

  return h(
    LinkWrapper,
    props,
    ...children,
  )
}

const WP_CONTENT_PREFIX = '/wp-content/'
const IMAGES_PREFIX = '/images/'
export const UPLOADS_PREFIX = '/uploads/'

export function isLegacyWPContent(href = '') {
  return href?.indexOf(WP_CONTENT_PREFIX) === 0 || href?.indexOf(IMAGES_PREFIX) === 0
}

export function isAbsoluteBlogUrl(href = '') {
  return href?.match(BLOG_ABSOLUTE_URL_REGEX)
}

export function processHref(href) {
  if (!href) {
    return href
  }

  let processed = href || ''

  if (isAbsoluteBlogUrl(href)) {
    // make absolute links relative
    processed = `/${href.match(BLOG_ABSOLUTE_URL_REGEX)[1]}`
  }

  if (isLegacyWPContent(processed)) {
    if (processed.indexOf(WP_CONTENT_PREFIX) === 0) {
      processed = `/${processed.substring(WP_CONTENT_PREFIX.length)}`
    }

    if (processed.indexOf(IMAGES_PREFIX) === 0) {
      processed = `/${processed.substring(IMAGES_PREFIX.length)}`
    }

    if (processed.indexOf(UPLOADS_PREFIX) !== 0) {
      processed = `${UPLOADS_PREFIX}${processed.replace(/^\//, '')}`
    }

    processed = `${BASE_STATIC_URL}/${processed.replace(/^\//, '')}`
  }

  return processed
}
